import { useContext, useState } from 'react';

import { MeetClassificationStateContext } from './MeetClassificationContextProvider';

import MeetClassificationData from './MeetClassificationData';

const useMeetClassificationData = () => {
  const [meetClassificationState, setMeetClassificationState] = useContext(MeetClassificationStateContext);
  const [meetClassificationNoContextState, setMeetClassificationNoContextState] = useState(MeetClassificationData.INITIAL_STATE);

  const getMeetClassificationsByOrgUnitId = (orgUnitId, filterId, filterMode) => {
    MeetClassificationData.getMeetClassificationsByOrgUnitId(orgUnitId, filterId, filterMode, meetClassificationState, setMeetClassificationState);
  };

  const getMeetClassificationsByOrgUnitIdNoContext = (orgUnitId, filterId, filterMode) => {
    MeetClassificationData.getMeetClassificationsByOrgUnitId(orgUnitId, filterId, filterMode, meetClassificationNoContextState, setMeetClassificationNoContextState);
  };

  return {
    meetClassificationState,
    setMeetClassificationState,
    getMeetClassificationsByOrgUnitId,
    meetClassificationNoContextState,
    setMeetClassificationNoContextState,
    getMeetClassificationsByOrgUnitIdNoContext
  };
};

export default useMeetClassificationData;
